/**
 * TODO: convert this to one dictionary with key as title and type as the section type - array/organization
 */
const titleToSectionKey = {
  'Personal Info': 'personalInfo',
  'Work Experience': 'workExperience',
  Education: 'education',
  Skills: 'skills',
  'Awards & Honors': 'awardsAndHonors',
  'Volunteer Work': 'volunteerWork',
  Certifications: 'certifications',
  Projects: 'projects',
  'Research Experience': 'researchExperience',
  'Hobbies & Interests': 'hobbiesAndInterests',
  Leadership: 'leadership',
  Associations: 'associations',
  'Extra Curricular Activities': 'extraCurricular',
  Languages: 'languages',
  Publications: 'publications',
  Courses: 'courses',
  'Conferences/Presentations': 'conferences',
  Patents: 'patents',
  'Test Scores': 'testScores',
  References: 'references',
  Summary: 'summary',
};
export default titleToSectionKey;

export const arraySections = {
  hobbiesAndInterests: true,
  languages: true,
  publications: true,
};

export const sectionKeyToUnderscore = {
  workExperience: 'WORK_EXPERIENCE',
  education: 'EDUCATION',
};

export const nodeToInputNames = {
  fullName: 'NAME',
  tagline: 'TAGLINE',
  phoneNumber: 'PHONE_NUMBER',
  email: 'EMAIL',
  personalLinks: 'PERSONAL_LINKS',
  address: 'ADDRESS',
  objective: 'CAREER_OBJECTIVE',
  volunteer_work_role_title: 'ROLE',
  volunteer_work_cause_title: 'CAUSE',
  volunteer_work_role_description: 'DESCRIPTION',
  work_experience_role_description: 'JOB_DESCRIPTION',
  work_experience_role_achievements: 'JOB_ACHIEVEMENTS',
  projects_project_description: 'DESCRIPTION',
  projects_url_title: 'ASSOCIATED_URL',
  extra_curricular_activity_description: 'DESCRIPTION',
  extra_curricular_url_title: 'ASSOCIATED_URL',
  research_experience_research_description: 'DESCRIPTION',
  research_experience_url_title: 'ASSOCIATED_URL',
  subjectLine: 'SUBJECT',
  letterBody: 'BODY',
  openGreeting: 'GREETING',
};

export const sectionKeysEnums = {
  SUMMARY: 'summary',
};

export const personalInfoComps = {
  fullName: true,
  tagline: true,
  phoneNumber: true,
  email: true,
  personalLinks: true,
  address: true,
  objective: true,
};

export const sectionKeys = Object.values(titleToSectionKey);

const getSectionKeyToTitle = () => {
  const sectionKeysToTitle = {};
  Object.keys(titleToSectionKey).forEach((title) => {
    const sectionKey = titleToSectionKey[title];
    sectionKeysToTitle[sectionKey] = title;
  });

  return sectionKeysToTitle;
};

export const sectionKeysToTitle = getSectionKeyToTitle();
